export default __webpack_public_path__ + "static/media/lele.navarro.5b5e5c0c.webp";